var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tabs',{staticClass:"finder-tab",attrs:{"fill":""},on:{"input":_vm.emitTab}},[_c('b-tab',{attrs:{"title":_vm.$t('Filter')}}),_c('b-tab',{attrs:{"title":_vm.$t('Search')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }